import React from 'react';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import CopyButton from '../../common/controls/CopyButton';
import Box from '@mui/material/Box';
import PetOwnerPetsList from '../lists/PetOwnerPetsList';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../hooks/useAuth';

export default function PetOwnerView({setPetOwners, handleEdit, open, onClose, petOwner = null}) { 

    const { role, isAuthenticated } = useAuth();

    const handleClose = () => {
        onClose();
    };

    const handleEditClick = () => {
        handleEdit(petOwner);
    };

    if (!petOwner) {
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            
            <DialogTitle>{role === 'guest' ? "Your Info" : "Pet Owner"}</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>First Name</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{petOwner.first_name}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Last Name</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{petOwner.last_name}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>E-mail</Typography>
                <Box display="inline-flex" alignItems="center">
                    <Typography variant="body1" sx={{ mt: 0 }}>{petOwner.email}</Typography>
                    <CopyButton text={petOwner.email} />
                </Box>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Contact Number</Typography>
                <Box display="inline-flex" alignItems="center">
                    <Typography variant="body1" sx={{ mt: 0 }}>{petOwner.contact_number}</Typography>
                    <CopyButton text={petOwner.contact_number} />
                </Box>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Address</Typography>
                <Box display="inline-flex" alignItems="center">
                    <Typography variant="body1" sx={{ mt: 0 }}>{petOwner.address ? petOwner.address : "(not provided)"}</Typography>
                    {petOwner.address ? <CopyButton text={petOwner.address} /> : null}
                </Box>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Created</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(petOwner.createdAt)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Last Updated</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(petOwner.updatedAt)}</Typography>

                <br />
                <Typography variant="h6">{role === 'guest' ? "Your Pets" : "Pets"}</Typography>
                <PetOwnerPetsList 
                    setPetOwners={setPetOwners}
                    petOwner={petOwner} 
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleEditClick}>
                    <EditIcon />
                </Button>
                <div style={{flex: '1 0 0'}} />
                {role === 'guest' ?
                <Button onClick={handleClose}>Done</Button>
                :
                <Button onClick={handleClose}>Close</Button>
                }
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}